import React from 'react';
import {SCHEDULE_FIELD_HEIGHT, SCHEDULE_FIELD_YEAR_WIDTH} from "../../constants/cssConstants";
import {Skeleton} from "@material-ui/lab";

class Years extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            plan: props.plan,
            isLoading: props.isLoading
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.isLoading !== this.props.isLoading) {
            this.setState({plan: this.props.plan, isLoading: this.props.isLoading});
        }
    }

    render() {
        const plan = this.state.plan;
        const years = this.state.isLoading ? [undefined,undefined,undefined,undefined]
            : [plan.enteringYear, plan.enteringYear + 1, plan.enteringYear + 2, plan.enteringYear + 3];
        return(
            <div style={{height: SCHEDULE_FIELD_HEIGHT - 20, width: SCHEDULE_FIELD_YEAR_WIDTH, marginTop: 20,
                display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                {
                    years.map((year) =>
                        <div style={{height: 100, width: 40, marginTop: 25, marginBottom: 25, writingMode: 'tb-rl',
                            transform: 'rotate(180deg)', display: 'flex', justifyContent: 'center',
                            alignItems: 'center', backgroundColor: '#99E1FF', borderRadius: 20}}>
                            {
                                year
                                    ? <div>{ year }</div>
                                    : <Skeleton variant={"rect"} width={20} height={70}/>
                            }
                        </div>
                    )
                }
            </div>
        );
    }
}

export default Years;